// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"15":"lang-fr-json","124":"lang-en-json","961":"lang-nl-json"}[chunkId] + "." + {"15":"562232d7118475fcd238","124":"c9819d6ee7152dc2a793","961":"814912856ce0b40bb42c"}[chunkId] + ".js";
};